import * as ApiManager from './_manager';
import store from '@/store';

export const bookings = {
  markSeatsLocked: (payload = null) => {
    return ApiManager.callApi (
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/screenings/${payload.screener_id}/bookings/markSeatsLocked`,
      payload
    );
  },
  bookSeats: (payload) => {
    return ApiManager.callApi (
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/screenings/${payload.screener_id}/bookings/bookSeats`,
      payload
    );
  },
  submitBookingQuery: (payload) => {
    return ApiManager.callApi (
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/screenings/${payload.screener_id}/bookings/${payload.booking_id}/submitBookingQuery`,
      payload
    );
  }
};
